import { HttpErrorResponse } from '@angular/common/http';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { DataSearchService } from '../services/data-search.service';
import { EMPTY } from 'rxjs'
import { IndividualConfig, ToastrService } from 'ngx-toastr';



@Injectable({
  providedIn: 'root'
})
export class SearchCarResolver implements Resolve<any> {
  constructor(private carService: VehiculeserviceService,
              private dataSearchService: DataSearchService,
              private router: Router,
              private toastr: ToastrService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    let obj;

    if(this.dataSearchService.diffDate == undefined || this.dataSearchService.diffDate == null) {

      if(this.dataSearchService.geometry != undefined || this.dataSearchService.geometry != null) {

        obj = {
          diffDate: this.dataSearchService.diffDate,
          lat: this.dataSearchService.geometry.location.lat(),
          lng: this.dataSearchService.geometry.location.lng(),
          model:this.dataSearchService.Model??null
        }

      }
      

    } else {

      obj = {
        diffDate: this.dataSearchService.diffDate,
        dateStart: this.dataSearchService.templateSearchCar.dateStart,
        dateEnd: this.dataSearchService.templateSearchCar.dateEnd,
        lat: this.dataSearchService.geometry.location.lat(),
        lng: this.dataSearchService.geometry.location.lng(),
        model:this.dataSearchService.Model??null
      }

    }


    // console.log(obj);

    // return this.carService.searchCar(obj).pipe(catchError(error => this.handleError(route, error)));

    if(this.dataSearchService.address != undefined) {

      return this.carService.searchCar(obj).pipe(catchError(error => this.handleError(route, error)));

    } else {

      this.toastr.show(
        'Oups, Une erreur est survenue lors de l\'execution',
        'Réesayez Réesayer',
        {
          timeOut: 5000,
          closeButton: true,
        } as IndividualConfig,
        'toast-' + 'error'
      )

      this.router.navigate(['/']);

      return EMPTY;

    }

  }

  handleError(route: ActivatedRouteSnapshot, errorResponse: HttpErrorResponse) {
    switch (errorResponse.status) {
      case 404: {
        this.router.navigate(['/**']);
        return Observable.arguments(null)
        // return Observable.of(null);
      }
      case 401: {
        const returnURL: string = '/' + route.url.map(segment => segment.path).join('/');
        this.router.navigate(['/login'], { queryParams: { returnURL: returnURL }});
        // return Observable.of(null);
        return Observable.arguments(null)
      }
      case 403: {
        this.router.navigate(['/unauthorized']);
        return Observable.arguments(null)
        // return Observable.of(null);
      }
      default: {
        
        this.toastr.show(
          'Oups, Une erreur est survenue lors de l\'execution',
          'Réesayez Réesayer',
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          'toast-' + 'error'
        )

        this.router.navigate(['/']);

        return Observable.arguments(null)
        
      }
    }
  }

}
